<div class="holidays-dates-bastch-actions border-r-16" *transloco="let t">
  <button [routerLink]="links.createHolidaysDates()" class="btn btn-primary btn-icon ms-auto">
    <i [class]="iconService.plus"></i>
    {{ t('settings/daysOff') }}
  </button>
</div>
